import { render, staticRenderFns } from "./penerimaanFpkkDetail.vue?vue&type=template&id=3834fc9e&scoped=true"
import script from "./penerimaanFpkkDetail.vue?vue&type=script&lang=js"
export * from "./penerimaanFpkkDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3834fc9e",
  null
  
)

export default component.exports